// =============================================================================
// Back-office: auditoría
// =============================================================================
import { apiClient } from './http';

export interface AuditEntry {
  id: number;
  timestamp: string;
  actor_name: string;
  actor_role: string;
  action: string;
  resource_type: string;
  resource_id: number | null;
  summary: string | null;
}

/**
 * El endpoint acepta `limit` (1..500) y `date_from`/`date_to` (audit.py).
 *
 * La pantalla pedía siempre las 100 últimas sin decir que había más: la cola
 * antigua del registro dejaba de ser accesible desde el producto con aspecto
 * de «todo el registro» (ronda 3, r2b20[5]). Aquí se exponen los tres cortes
 * para que la pantalla pueda traer más y acotar por fecha.
 */
export interface AuditQuery {
  limit?: number;
  dateFrom?: string;
  dateTo?: string;
}

export async function getAudit(query: AuditQuery = {}): Promise<AuditEntry[]> {
  const params = new URLSearchParams();
  params.append('limit', String(query.limit ?? 100));
  if (query.dateFrom) params.append('date_from', query.dateFrom);
  if (query.dateTo) params.append('date_to', query.dateTo);
  const res = await apiClient.get<AuditEntry[]>(`/audit?${params.toString()}`);
  return res.data;
}
